import React from "react"
import { DefaultHeader } from "."
import OnlineModal from "./Landing"

export default function Header() {
    return (
        <>
            <DefaultHeader />
            <OnlineModal />
        </>
    )
}
